import { Profile } from "../comparison_views/molecules/Profile";
import { Button, Box, Slide } from "@mui/material";
import { CloseIcon } from "../../atoms/icons/close";
import {
  adaptClosingDateToRateLockOptions,
  CustomRowWrapper,
  isFirstTimeHomebuyerOptions,
  lookingToOptions,
  occupancyTypeOptions,
  propertyTypeOptions,
  rateLockOptions,
  RowWrapper,
} from "./modal-utils";
import { IconWithTitle } from "../comparison_views/molecules/IconWithTitle";
import { PropertyTypeIcon } from "../../atoms/icons/property-type";
import { StandardSelectWithError } from "../../atoms/StandardSelect";
import { OccupancyTypeIcon } from "../../atoms/icons/occupancy-type";
import { LoanOptionBlockSmall } from "../comparison_views/molecules/LoanOptionBlockSmall";
import { UsCitizenIcon } from "../../atoms/icons/us-citizen";
import { YesNoButtonsWithError } from "../comparison_views/molecules/YesNoButtons";
import { VaEligibleIcon } from "../../atoms/icons/va-eligible";
import { CreditScoreIcon } from "../../atoms/icons/credit-score";
import { SelfEmployedIcon } from "../../atoms/icons/self-employed";
import { WaiveEscrowIcon } from "../../atoms/icons/waive-escrow";
import { PropertyValueIcon } from "../../atoms/icons/property-value";
import { MoneyUnderlinedInput } from "../../atoms/MoneyUnderlinedInput";
import { DownpaymentIcon } from "../../atoms/icons/downpayment";
import { RefreshIcon } from "../../atoms/icons/refresh";
import React, { useCallback, useRef, useState } from "react";
import { styled } from "@mui/system";
import { CreditScoreUnderlinedInput } from "../../atoms/CreditScoreInput";
import { RateLockPeriodIcon } from "../../atoms/icons/rate-lock-period";
import { ModifyDataPointModal } from "../../molecules/ModifyDataPointModal";
import { doNothing } from "@mui/x-date-pickers/internals/utils/utils";
import { comparePageValidationObject } from "../../util/comparePageValidationSchema";
import { FastTrackAddressButton } from "../../atoms/FastTrackAddressButton";
import CircularProgress from "@mui/material/CircularProgress";
import { FormHelperStyledError } from "../comparison_views/molecules/ui-utils";

const Container = styled("div")`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, 80px);
  grid-gap: 0 40px;
  grid-auto-flow: column;
  padding: 40px;
  max-width: 1800px;
  margin: 0 auto;

  @media (max-width: 1500px) {
    & {
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(7, 80px);
    }
  }

  @media (max-width: 1180px) {
    & {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(10, 80px);
    }
  }

  @media (max-width: 768px) {
    & {
      display: flex;
      flex-direction: column;
      gap: 40px;
    }
  }
`;

const ContainerItem = styled("div")``;

const LowerContainer = styled("div")`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  max-width: 1800px;
  margin: 0 auto;
  padding: 40px 40px 80px 40px;
  gap: 60px;
  justify-items: center;

  @media (max-width: 1500px) {
    & {
      grid-template-columns: repeat(3, 1fr);
    }
  }

  @media (max-width: 1180px) {
    & {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 768px) {
    & {
      grid-template-columns: repeat(1, 1fr);
    }
  }
`;

const LowerContainerItem = styled("div")``;

export const RefreshButton = styled(Button)`
  border-radius: 20px;
  background-color: #00e09d;
  color: white;
  padding-left: 50px;
  padding-right: 50px;
  text-transform: none;
  width: 350px;
  max-width: 350px;
  flex: 1;
  font-family: proxima-nova, sans-serif;
  font-weight: bold;
  font-size: 16px;

  &:hover {
    background-color: #009b62;
    color: white;
  }
`;

export const CloseButton = styled(Button)`
  border-radius: 20px;
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  font-weight: bold;
  padding-left: 40px;
  padding-right: 40px;
  display: flex;
  align-items: center;
  text-transform: none;

  &:hover {
    background-color: #243046;
  }
`;

export const FastTrackTitleWrapper = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

export const FastTrackIcon = styled("img")`
  height: 30px;
`;

export const FastTrackTitle = styled("h1")`
  font-family: "proxima-nova", sans-serif;
  font-weight: 300;
  color: white;
  text-transform: uppercase;
  font-size: 48px;
  margin: 0;
`;

export const FastTrackSubtitleWrapper = styled(FastTrackTitleWrapper)`
  background-color: #ffffff20;
  margin: 0 30px 30px 30px;
  border-radius: 12px;
`;

export const FastTrackSubtitle = styled("p")`
  color: white;
  font-family: "proxima-nova", sans-serif;
  font-weight: 300;
  font-size: 20px;
`;

export const DesktopSettingsModal = ({
  isFastTrack,
  open,
  onClose,
  lookingTo,
  formik,
  isRefinance,
  isRefinanceAndCashOut,
  isPurchase,
  isBuild,
  isLoading,
  onFormEdit,
}) => {
  const containerRef = useRef();
  const [shouldShowAddressModal, setShouldShowAddressModal] = useState(false);

  const showAddressModal = useCallback(() => {
    setShouldShowAddressModal(true);
  }, [setShouldShowAddressModal]);

  const hideAddressModal = useCallback(() => {
    setShouldShowAddressModal(false);
  }, [setShouldShowAddressModal]);

  const addressButtonCopy =
    formik.values.street || formik.values.city || formik.values.state
      ? `${formik.values.street}, ${formik.values.city}, ${formik.values.state}`
      : "Enter an address";

  const selfEmployedClassName = formik.values.isVeteran
    ? "tablet-shim-fix"
    : "";

  return (
    <Box
      sx={{
        pointerEvents: open ? "all" : "none",
        position: "absolute",
        top: 65,
        right: 0,
        left: 0,
        bottom: 0,
        zIndex: 1000,
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        backgroundColor: open ? "rgba(0, 0, 0, 0.5)" : "transparent",
      }}
      ref={containerRef}
    >
      <Slide
        in={open}
        direction="down"
        className="irq-modal-desktop"
        container={containerRef?.current}
        mountOnEnter
        unmountOnExit
      >
        <div>
          <div className="top-modal-wrapper">
            <div className="justified-row-wrapper">
              <Profile display />
              {!isFastTrack && (
                <CloseButton
                  onClick={onClose}
                  variant="contained"
                  startIcon={<CloseIcon fill="white" width={30} height={30} />}
                >
                  Close Profile Settings
                </CloseButton>
              )}
            </div>
            {isFastTrack && (
              <>
                <FastTrackTitleWrapper>
                  <FastTrackIcon src="/img/svg_icons/fast_track.svg" />
                  <FastTrackTitle>Instant Rate Quote</FastTrackTitle>
                </FastTrackTitleWrapper>
                <FastTrackSubtitleWrapper>
                  <FastTrackSubtitle>
                    Fill in the information below to view today's loan options.
                  </FastTrackSubtitle>
                </FastTrackSubtitleWrapper>
              </>
            )}

            <Container>
              <ContainerItem style={{ marginTop: -20 }}>
                <CustomRowWrapper>
                  <div className="loan-types-wrapper">
                    I am a:
                    <StandardSelectWithError
                      options={isFirstTimeHomebuyerOptions}
                      name="isFirstTimeHomebuyer"
                      value={formik.values.isFirstTimeHomebuyer}
                      onChange={formik.handleChange}
                      helperText={
                        formik.touched.isFirstTimeHomebuyer &&
                        formik.errors.isFirstTimeHomebuyer
                      }
                      error={
                        formik.touched.isFirstTimeHomebuyer &&
                        formik.errors.isFirstTimeHomebuyer
                      }
                    />
                  </div>
                  <div className="loan-types-wrapper">
                    Looking to:
                    <StandardSelectWithError
                      options={lookingToOptions}
                      name="lookingTo"
                      value={lookingTo}
                      onChange={(...params) => {
                        onFormEdit(...params);
                        // required to force Formik to revalidate the field on change of context to Refinance
                        setTimeout(() => formik.validateForm(), 1);
                      }}
                    />
                  </div>
                </CustomRowWrapper>
              </ContainerItem>

              <ContainerItem>
                <RowWrapper>
                  <IconWithTitle
                    title="Occupancy Type"
                    icon={<OccupancyTypeIcon />}
                  />
                  <StandardSelectWithError
                    options={occupancyTypeOptions}
                    name="occupancyType"
                    value={formik.values.occupancyType}
                    onChange={formik.handleChange}
                    helperText={
                      formik.touched.occupancyType &&
                      formik.errors.occupancyType
                    }
                    error={
                      formik.touched.occupancyType &&
                      formik.errors.occupancyType
                    }
                  />
                </RowWrapper>
              </ContainerItem>

              <ContainerItem>
                <FastTrackAddressButton
                  onClick={showAddressModal}
                  placeholder={addressButtonCopy}
                />
                {formik.touched.street && formik.errors.street && (
                  <FormHelperStyledError>
                    {formik.errors.street}
                  </FormHelperStyledError>
                )}
              </ContainerItem>

              <ContainerItem style={{ gridRow: "span 3" }}>
                <div className="loan-types-wrapper">
                  Loan Types
                  <LoanOptionBlockSmall
                    showError={
                      !!formik.touched.loanOptions &&
                      !!formik.errors.loanOptions
                    }
                    loanOptions={formik.values.loanOptions}
                    customFormEdit={(name, value) =>
                      formik.handleChange({
                        target: {
                          name: "loanOptions",
                          value,
                        },
                      })
                    }
                  />
                </div>
              </ContainerItem>

              <ContainerItem>
                <RowWrapper>
                  <IconWithTitle title="US Citizen?" icon={<UsCitizenIcon />} />
                  <YesNoButtonsWithError
                    values={[true, false]}
                    value={formik.values.isUsCitizen}
                    handleClick={(val) => {
                      formik.handleChange({
                        target: {
                          name: "isUsCitizen",
                          value: val,
                        },
                      });
                    }}
                    helperText={
                      formik.touched.isUsCitizen && formik.errors.isUsCitizen
                    }
                    error={
                      formik.touched.isUsCitizen && formik.errors.isUsCitizen
                    }
                  />
                </RowWrapper>
              </ContainerItem>

              {formik.values.occupancyType === "Primary" && (
                <ContainerItem>
                  <RowWrapper>
                    <IconWithTitle
                      title="VA Eligible?"
                      icon={<VaEligibleIcon />}
                    />
                    <YesNoButtonsWithError
                      values={[true, false]}
                      value={formik.values.isVeteran}
                      handleClick={(val) => {
                        formik.handleChange({
                          target: {
                            name: "isVeteran",
                            value: val,
                          },
                        });
                      }}
                      helperText={
                        formik.touched.isVeteran && formik.errors.isVeteran
                      }
                      error={
                        formik.touched.isUsCitizen && formik.errors.isVeteran
                      }
                    />
                  </RowWrapper>
                </ContainerItem>
              )}

              {formik.values.isVeteran &&
                formik.values.occupancyType === "Primary" && (
                  <>
                    <ContainerItem>
                      <RowWrapper>
                        <IconWithTitle
                          title="First VA Loan?"
                          icon={<VaEligibleIcon />}
                        />
                        <YesNoButtonsWithError
                          values={[true, false]}
                          value={formik.values.vaFirstTimeUse}
                          handleClick={(val) => {
                            formik.handleChange({
                              target: {
                                name: "vaFirstTimeUse",
                                value: val,
                              },
                            });
                          }}
                          helperText={
                            formik.touched.vaFirstTimeUse &&
                            formik.errors.vaFirstTimeUse
                          }
                          error={
                            formik.touched.vaFirstTimeUse &&
                            formik.errors.vaFirstTimeUse
                          }
                        />
                      </RowWrapper>
                    </ContainerItem>

                    <ContainerItem className="tablet-shim-fix">
                      <RowWrapper>
                        <IconWithTitle
                          title="Are you disabled?"
                          icon={<VaEligibleIcon />}
                        />
                        <YesNoButtonsWithError
                          className="yes-no-modal-shim"
                          values={[true, false]}
                          value={formik.values.disabledVeteran}
                          handleClick={(val) => {
                            formik.handleChange({
                              target: {
                                name: "disabledVeteran",
                                value: val,
                              },
                            });
                          }}
                          helperText={
                            formik.touched.disabledVeteran &&
                            formik.errors.disabledVeteran
                          }
                          error={
                            formik.touched.disabledVeteran &&
                            formik.errors.disabledVeteran
                          }
                        />
                      </RowWrapper>
                    </ContainerItem>
                  </>
                )}

              <ContainerItem className={selfEmployedClassName}>
                <RowWrapper>
                  <IconWithTitle
                    title="Self-Employed?"
                    icon={<SelfEmployedIcon />}
                    customStyle={{ minWidth: 160 }}
                  />
                  <YesNoButtonsWithError
                    className="yes-no-modal-shim"
                    values={[true, false]}
                    value={formik.values.isSelfEmployed}
                    handleClick={(val) => {
                      formik.handleChange({
                        target: {
                          name: "isSelfEmployed",
                          value: val,
                        },
                      });
                    }}
                    helperText={
                      formik.touched.isSelfEmployed &&
                      formik.errors.isSelfEmployed
                    }
                    error={
                      formik.touched.isSelfEmployed &&
                      formik.errors.isSelfEmployed
                    }
                  />
                </RowWrapper>
              </ContainerItem>

              {(isPurchase || isBuild) && (
                <ContainerItem className="tablet-shim-fix">
                  <RowWrapper>
                    <IconWithTitle
                      title="Rate Lock Period"
                      icon={
                        <RateLockPeriodIcon
                          fill="white"
                          height={30}
                          width={30}
                        />
                      }
                    />
                    <StandardSelectWithError
                      options={rateLockOptions}
                      name="plannedClosingDate"
                      value={adaptClosingDateToRateLockOptions(
                        formik.values.plannedClosingDate
                      )}
                      onChange={formik.handleChange}
                      helperText={
                        formik.touched.plannedClosingDate &&
                        formik.errors.plannedClosingDate
                      }
                      error={
                        formik.touched.plannedClosingDate &&
                        formik.errors.plannedClosingDate
                      }
                      width={188}
                    />
                  </RowWrapper>
                </ContainerItem>
              )}

              <ContainerItem className="tablet-shim-fix">
                <RowWrapper>
                  <IconWithTitle
                    title="Waive Escrow?"
                    icon={<WaiveEscrowIcon />}
                    customStyle={{ minWidth: 160 }}
                  />
                  <YesNoButtonsWithError
                    className="yes-no-modal-shim"
                    values={["Yes", "No"]}
                    value={formik.values.hasWaivedEscrow}
                    handleClick={(val) => {
                      formik.handleChange({
                        target: {
                          name: "hasWaivedEscrow",
                          value: val,
                        },
                      });
                    }}
                    helperText={
                      formik.touched.hasWaivedEscrow &&
                      formik.errors.hasWaivedEscrow
                    }
                    error={
                      formik.touched.hasWaivedEscrow &&
                      formik.errors.hasWaivedEscrow
                    }
                  />
                </RowWrapper>
              </ContainerItem>

              {isRefinanceAndCashOut && (
                <ContainerItem>
                  <div className="settings-modal-input-wrapper">
                    <DownpaymentIcon fill="white" />
                    Amount of Cash Out:
                    <div className="margin-left">
                      <MoneyUnderlinedInput
                        name="amountOfCashOut"
                        value={formik.values.amountOfCashOut}
                        onChange={formik.handleChange}
                        helperText={
                          formik.touched.amountOfCashOut &&
                          formik.errors.amountOfCashOut
                        }
                        error={
                          formik.touched.amountOfCashOut &&
                          formik.errors.amountOfCashOut
                        }
                      />
                    </div>
                  </div>
                </ContainerItem>
              )}
            </Container>

            <LowerContainer>
              <LowerContainerItem>
                <div className="settings-modal-input-wrapper">
                  <PropertyValueIcon fill="white" />
                  Property Value:
                  <div className="margin-left">
                    <MoneyUnderlinedInput
                      name="price"
                      value={formik.values.price}
                      onChange={formik.handleChange}
                      helperText={formik.touched.price && formik.errors.price}
                      error={formik.touched.price && formik.errors.price}
                    />
                  </div>
                </div>
              </LowerContainerItem>

              {(isPurchase || isBuild) && (
                <LowerContainerItem>
                  <div className="settings-modal-input-wrapper">
                    <DownpaymentIcon fill="white" />
                    Down payment:
                    <div className="margin-left">
                      <MoneyUnderlinedInput
                        name="downPayment"
                        value={formik.values.downPayment}
                        onChange={formik.handleChange}
                        helperText={
                          formik.touched.downPayment &&
                          formik.errors.downPayment
                        }
                        error={
                          formik.touched.downPayment &&
                          formik.errors.downPayment
                        }
                        inputProps={{ max: formik.values.price, min: 0 }}
                      />
                    </div>
                  </div>
                </LowerContainerItem>
              )}

              {(isRefinance || isRefinanceAndCashOut) && (
                <LowerContainerItem>
                  <div className="settings-modal-input-wrapper">
                    <DownpaymentIcon fill="white" />
                    Loan Balance:
                    <div className="margin-left">
                      <MoneyUnderlinedInput
                        name="existingLoanBalance"
                        value={formik.values.existingLoanBalance}
                        onChange={formik.handleChange}
                        helperText={
                          formik.touched.existingLoanBalance &&
                          formik.errors.existingLoanBalance
                        }
                        error={
                          formik.touched.existingLoanBalance &&
                          formik.errors.existingLoanBalance
                        }
                      />
                    </div>
                  </div>
                </LowerContainerItem>
              )}

              <LowerContainerItem>
                <div className="settings-modal-input-wrapper">
                  <CreditScoreIcon fill="white" />
                  Credit Score:
                  <div className="margin-left">
                    <CreditScoreUnderlinedInput
                      name="creditScore"
                      placeholder="e.g. 700"
                      value={formik.values.creditScore}
                      onChange={formik.handleChange}
                      helperText={
                        formik.touched.creditScore && formik.errors.creditScore
                      }
                      error={
                        formik.touched.creditScore && formik.errors.creditScore
                      }
                    />
                  </div>
                </div>
              </LowerContainerItem>

              <LowerContainerItem>
                {isLoading ? (
                  <CircularProgress sx={{ color: "white" }} />
                ) : (
                  <RefreshButton
                    variant="contained"
                    startIcon={
                      isFastTrack ? undefined : (
                        <RefreshIcon
                          fill={formik.isValid ? "white" : "#00000040"}
                          width={20}
                          height={20}
                        />
                      )
                    }
                    type="submit"
                    onClick={formik.handleSubmit}
                  >
                    {isFastTrack ? "View Rates" : "Refresh Rates"}
                  </RefreshButton>
                )}
              </LowerContainerItem>
            </LowerContainer>

            <ModifyDataPointModal
              open={shouldShowAddressModal}
              onClose={hideAddressModal}
              setFirstTimeBuyer={doNothing}
              data={{
                street: formik.values.street,
                city: formik.values.city,
                county: formik.values.county,
                state: formik.values.state,
                zip: formik.values.zip,
              }}
              openDataName="street"
              customFormEdit={doNothing}
              onFormEdit={doNothing}
              onSubmitAddress={(address) => {
                formik.setValues(
                  {
                    ...formik.values,
                    street: address.street,
                    city: address.city,
                    county: address.county,
                    countyFips: address.countyFips,
                    state: address.state,
                    stateFips: address.stateFips,
                    zip: address.zip,
                    propertyType: address.propertyType,
                    neighborhood: address.neighborhood,
                  },
                  true
                );
              }}
              validationObject={comparePageValidationObject}
            />
          </div>
        </div>
      </Slide>
      <Box
        sx={{
          backgroundColor: "transparent",
          flex: 1,
        }}
        onClick={onClose}
      />
    </Box>
  );
};
